import { render } from "./HeroiconsSolidPause.vue?vue&type=template&id=5cb59bce"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPause.vue"]])

export default __exports__